
















































































// import Vue from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { Round } from "../store/interfaces";

@Component
export default class Team extends Vue {
  //PROPS
  @Prop(Number) index!: number;
  @Prop(Boolean) mobile!: boolean;

  // DATA
  clicked = false;

  // CALCULATED
  get teamNum() {
    return this.$store.state.teams[this.index].teamNum;
  }
  set teamNum(newNum) {
    this.$store.commit("updateNum", { value: newNum, index: this.index });
  }
  get teamName() {
    return this.$store.state.teams[this.index].teamName;
  }
  set teamName(newName: string) {
    this.$store.commit("updateName", { value: newName, index: this.index });
  }
  get rounds() {
    return this.$store.state.teams[this.index].rounds;
  }
  get total() {
    return this.rounds.reduce(
      (total: number, round: Round) => total + round.gained,
      0
    );
  }

  // METHODS
  getRoundTotal(index: number) {
    let result = 0;
    for (let i = 0; i < index + 1; i++) {
      result += parseInt(this.rounds[i].gained);
    }
    return result;
  }
  updateRound(event: any) {
    const roundScore = parseInt(event.target.value);
    const roundToScore = parseInt(event.target.id.slice(-1));
    this.$store.commit("updateRounds", {
      round: roundToScore,
      score: roundScore,
      index: this.index,
    });
  }
  setUpRoundBreakdown(round: Round) {
    if (!round.breakdown) return null;

    const { correctAnswers, doubleDown, bonus } = round.breakdown;

    let resultString = `Correct Answers: ${correctAnswers}` + "\n";

    resultString += doubleDown
      ? `Double Down: ${String.fromCharCode(0x2713)}` + "\n"
      : "";

    resultString += bonus ? "Bonus Points: 2\n" : "";

    return resultString;
  }
  select(arg: string) {
    let id;
    if (arg === "score") {
      id = `score-${this.index}-${arguments[1]}`;
    } else {
      id = `${arg}-${this.index}`;
    }

    const element: HTMLInputElement = document.getElementById(
      id
    ) as HTMLInputElement;
    element.select();
  }
  expandRoundList() {
    this.clicked = !this.clicked;
  }
  deleteTeam() {
    this.$store.commit("deleteTeam", { name: this.teamName });
  }
}
